import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import EmptyLine from "../EmptyLine";
import {useModal} from "../../../context/ModalContext";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B2({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()

    switch (row.error_id) {
        case MessageCodes.Internal.FW02.error_id: {
            return (
                <>
                    <ResultText>
                        There are issues with the encroachment station placement at the following {row?.data?.length} cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Bank</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(35)}}>Issue</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName
                                                csNameVal={r.cross_section}
                                                csName={r.cross_section}
                                            />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.side || '-'}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.issue}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }

        case MessageCodes.Internal.ENCR00.error_id: {
            return (
                <ResultText>
                    {row.error_message}
                </ResultText>
            )
        }
    }
}